import React from 'react';

export default function VersionBanner({ onReload }) {
  return (
    <div
      className="
        fixed inset-x-0 z-50 no-print
        sm:left-1/2 sm:-translate-x-1/2 sm:inset-x-auto sm:w-[min(92vw,28rem)]
      "
      // podigni baner iznad dna + safe-area
      style={{ bottom: 'calc(env(safe-area-inset-bottom, 0px) + 16px)' }}
    >
      <div
        className="
          mx-3 sm:mx-0
          bg-amber-100 border border-amber-300 text-amber-900
          rounded-xl shadow-lg
          px-3 py-3
          dark:bg-slate-800 dark:text-amber-100 dark:border-slate-600
        "
        role="status"
        aria-live="polite"
      >
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
          <span className="text-sm sm:text-base leading-tight">
            New version is available.
          </span>
          <div className="flex gap-2 sm:ml-auto">
            <button
              onClick={onReload}
              className="
                w-full sm:w-auto
                inline-flex items-center justify-center
                px-4 py-2 text-sm font-medium rounded-md
                bg-blue-600 text-white hover:bg-blue-700
                focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
                dark:focus:ring-offset-slate-800
              "
            >
              Reload
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

